import http_request from './http_request'
import config from 'config'

function getQuiz(id, jwt) {
	const headers = {}
	if (jwt) {
		headers.jwt = jwt
	}
	return http_request.get(config.api + 'quiz/' + id)
		.withHeaders(headers)
		.send()
}

function saveTitle(instructions, id) {
	return http_request.put(config.api + 'quiz/' + id + '/title')
		.send({
			text: instructions,
		})
}

function addQuestion(slideId) {
	return http_request.post(config.api + 'questions')
		.send({
			slide_id: slideId,
		})
}

function duplicateQuestion(slideId, presentationId, value, iconId, answers, orden) {
	return http_request.post(config.api + 'questions')
		.send({
			slide_id: slideId,
			presentation_id: presentationId,
			text: value,
			icon_id: iconId,
			answers,
			orden,
		})
}

function updateQuestion(value, id, iconId, answers) {
	return http_request.put(config.api + 'questions/' + id)
		.send({
			text: value,
			icon_id: iconId,
			answers,
		})
}

function deleteQuestion(id) {
	return http_request.delete(config.api + 'questions/' + id)
		.send()
}

function dropQuestion(id, questions) {
	return http_request.put(config.api + 'quiz/' + id + '/sort')
		.send({
			questions,
		})
}

function saveQuiz(id) {
	return http_request.put(config.api + 'quiz/' + id)
		.send()
}

export default {
	getQuiz,
	saveTitle,
	addQuestion,
	duplicateQuestion,
	updateQuestion,
	deleteQuestion,
	dropQuestion,
	saveQuiz,
}
